import { defineComponent as _defineComponent } from 'vue'
import { useHostServices } from '@/composables/format-edit/useHostServices'
import { useRirekishoFormatData } from '@/composables/format-edit/useRirekishoFormatData'
import hobbyOptions from '@/utils/format-edit/designRirekishoHobbyOptions.json'


export default /*#__PURE__*/_defineComponent({
  __name: 'DesignRirekishoHobbyPickerCard',
  props: {
    currentCardId: null
  },
  setup(__props: any) {



const { message } = useHostServices()
const formatData = useRirekishoFormatData()

function ensureHobbies() {
  if (!formatData.hobbies) {
    formatData.hobbies = []
  }
  return formatData.hobbies
}

function selectHobby(idx: number, val: string) {
  const hobbies = ensureHobbies()
  let isExistIndex = -1
  for (let i = 0; i < hobbies.length; i++) {
    if (hobbies[i].id === idx) {
      isExistIndex = i
      break
    }
  }
  if (isExistIndex >= 0) {
    hobbies.splice(isExistIndex, 1)
    return
  }
  if (hobbies.length >= 9) {
    message({
      message: '趣味は最大9つまで選択可能です。',
      type: 'error'
    })
    return
  }
  hobbies.push({ id: idx, name: val })
}

function checkedHobby(idx: number) {
  const hobbies = formatData.hobbies || []
  for (let i = 0; i < hobbies.length; i++) {
    if (hobbies[i].id === idx) {
      return 'seleted'
    }
  }
  return ''
}

return { __sfc: true,message, formatData, ensureHobbies, selectHobby, checkedHobby, hobbyOptions }
}

})